<div class="wrapper">
  <h4 class="text">{{"Toggler.Type" | translate}}</h4>
  <div>
    <input [checked]="mode === 'rules'" (change)="changeMode()" class="checkbox" id="switch" type="checkbox" />
    <label class="label" for="switch">
      <span class="button"></span>
    </label>
  </div>
</div>